import { Button } from "@heroui/react";
import { Outlet } from "react-router-dom";

import { useAuth } from "@/features/auth/AuthProvider";
import { WorkspaceSwitcher } from "@/features/workspaces/WorkspaceSwitcher";

export function AppLayout() {
  const { session, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-separator bg-background">
        <nav
          aria-label="Workspace navigation"
          className="mx-auto flex min-h-20 max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-3"
        >
          <a className="text-xl font-semibold" href="/">
            Colorthesia
          </a>
          <div className="flex items-center gap-3">
            <a className="text-sm font-medium" href="/admin">Admin</a>
            <WorkspaceSwitcher />
            <span className="hidden text-sm text-muted sm:inline">
              {session?.user?.name ?? session?.user?.email}
            </span>
            <Button variant="tertiary" onPress={() => void signOut()}>
              Sign out
            </Button>
          </div>
        </nav>
      </header>
      <Outlet />
    </div>
  );
}
